import React, { useState } from 'react';
import { Box, Typography, Grid, Divider, Button } from '@mui/material';
import m6 from './Asset/m6-blue-fix-fixed.webp';
import atto from './Asset/atto3-white-fix.webp';
import dolphin from './Asset/dolphin-fix.webp';
import seal from './Asset/seal-fix.webp';
import sealion7 from './Asset/byd-sealion-7-2.webp';
import denzad9 from './Asset/denzad9.webp';
import seagull from './Asset/seagull.webp';
import denzab5 from './Gallery/pricing.webp';
import { Helmet } from 'react-helmet-async';

function Pricing() {
  const [selectedVariants, setSelectedVariants] = useState({});

  const vehicles = [
    {
      name: 'DENZA B5',
      image: denzab5,
      isNew: true,
      variants: [
        {
          type: '4X4 (PHEV)',
          price: 'Indent Sekarang!',
          description: 'Info & booking via WhatsApp',
          details: [
            {
              label: 'Sistem Hybrid',
              value: 'Plug-in Hybrid (PHEV) “Super Hybrid”',
            },
            { label: 'Mesin', value: '1.5L turbo 4-silinder' },
            {
              label: 'Penggerak',
              value: 'AWD (motor listrik depan + belakang)',
            },
            { label: 'Output Gabungan', value: '400 kW / 760 Nm' },
            { label: '0–100 km/jam', value: '4,8 detik' },
            { label: 'Kapasitas Baterai', value: '31,8 kWh (LFP)' },
            { label: 'Jarak EV (WLTC)', value: '90 km' },
            { label: 'Jarak Kombinasi (WLTC)', value: '850 km' },
            { label: 'Konsumsi (WLTC, baterai penuh)', value: '3,9 L/100 km' },
            { label: 'Konsumsi (WLTC, baterai habis)', value: '10,9 L/100 km' },
            { label: 'Kapasitas Towing (braked)', value: '3.000 kg' },
            { label: 'Kursi', value: '5 penumpang' },
          ],
        },
      ],
    },
    {
      name: 'BYD ATTO 1',
      image: seagull,
      isNew: true,
      variants: [
        {
          type: 'Dynamic',
          price: 'Rp205.000.000',
          details: [
            { label: 'Jarak Tempuh (NEDC)', value: '300 km' },
            { label: 'Kapasitas Baterai', value: '30.08 kWh' },
            { label: 'Tenaga Maksimum', value: '55 kW' },
            { label: 'Torsi Maksimum', value: '135 Nm' },
            { label: 'Akselerasi 0-50 km/h', value: '4.9 detik' },
            { label: 'Kecepatan Maksimum', value: '130 km/h' },
            { label: 'Pengisian DC', value: '30 kW (30–80% ±30 menit)' },
            { label: 'Pengisian AC', value: '6.6 kW' },
            { label: 'Ukuran Ban', value: '185/55 R16' },
            { label: 'Berat Kosong', value: '1.225 kg' },
            { label: 'Jumlah Airbag', value: '4' },
            { label: 'Kunci Digital', value: 'NFC + Bluetooth' },
            {
              label: 'Layar',
              value: '10.1" Touchscreen, CarPlay, Android Auto',
            },
          ],
        },
        {
          type: 'Premium (Extended Range)',
          price: 'Rp241.000.000',
          details: [
            { label: 'Jarak Tempuh (NEDC)', value: '380 km' },
            { label: 'Kapasitas Baterai', value: '38.88 kWh' },
            { label: 'Tenaga Maksimum', value: '55 kW' },
            { label: 'Torsi Maksimum', value: '135 Nm' },
            { label: 'Akselerasi 0-50 km/h', value: '4.9 detik' },
            { label: 'Kecepatan Maksimum', value: '130 km/h' },
            { label: 'Pengisian DC', value: '40 kW (30–80% ±30 menit)' },
            { label: 'Pengisian AC', value: '6.6 kW' },
            { label: 'Ukuran Ban', value: '185/55 R16' },
            { label: 'Berat Kosong', value: '1.280 kg' },
            { label: 'Jumlah Airbag', value: '6 (termasuk Side Airbag)' },
            { label: 'Kunci Digital', value: 'NFC + Bluetooth' },
            {
              label: 'Layar',
              value: '10.1" Touchscreen, CarPlay, Android Auto',
            },
            { label: 'Wireless Charging', value: '✔️' },
            { label: 'Electric Seat Adjustment', value: '✔️ (6-way)' },
          ],
        },
      ],
    },
    {
      name: 'BYD DENZA D9',
      image: denzad9,
      variants: [
        {
          type: 'Standard',
          price: 'Rp950.000.000',
          description: 'Harga mulai Rp950.000.000',
          details: [
            { label: 'Tenaga Maksimum', value: '230 kW' },
            { label: 'Kapasitas Baterai', value: '103,36 kWh' },
            { label: 'Jarak Tempuh (NEDC)', value: '600 km' },
            { label: 'Akselerasi 0-100 km/jam', value: '9,5 detik' },
            { label: 'Pengisian Cepat', value: '166 kW' },
            { label: 'Wheelbase', value: '3.110 mm' },
          ],
        },
      ],
    },
    {
      name: 'BYD SEALION 7',
      image: sealion7,
      variants: [
        {
          type: 'Performance (AWD)',
          price: 'Rp719.000.000',
          description: 'mulai dari Rp719.000.000',
          details: [
            { label: 'Torsi Maksimum', value: '690 Nm' },
            { label: 'Daya Maksimum', value: '390 kW / 523 HP' },
            { label: 'Jarak Mengemudi NEDC', value: '542 km' },
            { label: 'Kapasitas Baterai', value: '82.56 kWh' },
            { label: '0-100 km/h', value: '4.5 s' },
            { label: 'Kecepatan Maksimum', value: '215 km/h' },
            { label: 'Rate Vehicle-to-Load', value: '3.3 kW' },
          ],
        },
        {
          type: 'Premium (Extended Range)',
          price: 'Rp629.000.000',
          description: 'mulai dari Rp629.000.000',
          details: [
            { label: 'Torsi Maksimum', value: '380 Nm' },
            { label: 'Daya Maksimum', value: '230 kW / 267 HP' },
            { label: 'Jarak Mengemudi NEDC', value: '567 km' },
            { label: 'Kapasitas Baterai', value: '82.56 kWh' },
            { label: '0-100 km/h', value: '6.7 s' },
            { label: 'Kecepatan Maksimum', value: '215 km/h' },
            { label: 'Rate Vehicle-to-Load', value: '3.3 kW' },
          ],
        },
      ],
    },
    {
      name: 'BYD SEAL',
      image: seal,
      variants: [
        {
          type: 'Performance (AWD)',
          price: 'Rp750.000.000',
          description: 'mulai dari Rp750.000.000',
          details: [
            { label: 'Torsi Maksimum', value: '670 N.m' },
            { label: 'Daya Maksimum', value: '390 kW' },
            { label: 'Jarak Mengemudi NEDC', value: '580 km' },
            { label: 'Kapasitas Baterai', value: '82.56 kWh' },
            { label: '0-100 km/h', value: '3.8 s' },
          ],
        },
        {
          type: 'Premium (Extended Range)',
          price: 'Rp639.000.000',
          description: 'mulai dari Rp639.000.000',
          details: [
            { label: 'Torsi Maksimum', value: '360 N.m' },
            { label: 'Daya Maksimum', value: '230 kW' },
            { label: 'Jarak Mengemudi NEDC', value: '650 km' },
            { label: 'Kapasitas Baterai', value: '82.56 kWh' },
            { label: '0-100 km/h', value: '5.9 s' },
          ],
        },
      ],
    },
    {
      name: 'BYD ATTO 3',
      image: atto,
      variants: [
        {
          type: 'Advanced',
          price: 'Rp390.000.000',
          description: 'mulai dari Rp390.000.000',
          details: [
            { label: 'Kapasitas Baterai', value: '49 kWh' },
            { label: 'Daya Maksimum', value: '204 hp' },
            { label: 'Torsi Maksimum', value: '310 Nm' },
            { label: '0-100 km/h', value: '7.9 s' },
            { label: 'Jarak Tempuh', value: '410 km' },
            { label: 'Kecepatan Maksimum', value: '160 km/h' },
          ],
        },
        {
          type: 'Advanced Plus',
          price: 'Rp415.000.000',
          description: 'mulai dari Rp415.000.000',
          details: [
            { label: 'Kapasitas Baterai', value: '49.92 kWh' },
            { label: 'Daya Maksimum', value: '150 kW' },
            { label: 'Torsi Maksimum', value: '310 N.m' },
            { label: '0-100 km/h', value: '7.9 s' },
            { label: 'Jarak Tempuh NEDC', value: '410 km' },
            { label: 'Pengisian DC', value: '70 kW (30–80% ~45 menit)' },
          ],
        },
      ],
    },
    {
      name: 'BYD DOLPHIN',
      image: dolphin,
      variants: [
        {
          type: 'Dynamic (Standard Range)',
          price: 'Rp369.000.000',
          description: 'mulai dari Rp369.000.000',
          details: [
            { label: 'Torsi Maksimum', value: '180 N.m' },
            { label: 'Daya Maksimum', value: '70 kW' },
            { label: 'Jarak Mengemudi NEDC', value: '410 km' },
            { label: 'Kapasitas Baterai', value: '44.9 kWh' },
            { label: '0-100 km/h', value: '12.3 s' },
          ],
        },
        {
          type: 'Premium (Extended Range)',
          price: 'Rp429.000.000',
          description: 'mulai dari Rp429.000.000',
          details: [
            { label: 'Torsi Maksimum', value: '310 N.m' },
            { label: 'Daya Maksimum', value: '150 kW' },
            { label: 'Jarak Mengemudi NEDC', value: '490 km' },
            { label: 'Kapasitas Baterai', value: '60.48 kWh' },
            { label: '0-100 km/h', value: '7.0 s' },
          ],
        },
      ],
    },
    {
      name: 'BYD M6',
      image: m6,
      variants: [
        {
          type: 'Standard (7 Seater)',
          price: 'Rp383.000.000',
          description: 'mulai dari Rp383.000.000',
          details: [
            { label: 'Torsi Maksimum', value: '310 N.m' },
            { label: 'Daya Maksimum', value: '120 kW' },
            { label: 'Jarak Mengemudi NEDC', value: '420 km' },
            { label: 'Kapasitas Baterai', value: '55.4 kWh' },
            { label: '0-100 km/h', value: '10.1 s' },
          ],
        },
        {
          type: 'Superior (7 Seater)',
          price: 'Rp423.000.000',
          description: 'mulai dari Rp423.000.000',
          details: [
            { label: 'Torsi Maksimum', value: '310 N.m' },
            { label: 'Daya Maksimum', value: '150 kW' },
            { label: 'Jarak Mengemudi NEDC', value: '530 km' },
            { label: 'Kapasitas Baterai', value: '71.8 kWh' },
            { label: '0-100 km/h', value: '8.6 s' },
          ],
        },
        {
          type: 'Superior Captain (6 Seater)',
          price: 'Rp433.000.000',
          description: 'mulai dari Rp433.000.000',
          details: [
            { label: 'Torsi Maksimum', value: '310 N.m' },
            { label: 'Daya Maksimum', value: '150 kW' },
            { label: 'Jarak Mengemudi NEDC', value: '530 km' },
            { label: 'Kapasitas Baterai', value: '71.8 kWh' },
            { label: '0-100 km/h', value: '8.6 s' },
          ],
        },
      ],
    },
  ];

  return (
    <Box sx={{ padding: { xs: 2, sm: 4 } }}>
      <Helmet>
        <title>Harga BYD BSD Serpong - Dealer Resmi di BSD Serpong</title>
        <meta
          name='description'
          content='Temukan Harga BYD di Dealer Resmi BYD BSD Serpong. Dapatkan promo terbaik untuk mobil listrik di lokasi Anda!'
        />
        <meta
          name='keywords'
          content='byd Atto1 indonesia harga, denza d9 harga indonesia, byd sealion 7 indonesia harga, BYD BSD Serpong'
        />
        <meta name='author' content='BYD BSD Serpong Junius' />
        <meta name='geo.region' content='ID-BT' />
        <meta
          name='geo.placename'
          content='BSD Serpong, Tangerang Selatan, Indonesia'
        />
        <meta name='geo.position' content='-6.3046;106.6496' />
        <meta name='ICBM' content='-6.3046, 106.6496' />
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: 'BYD BSD Serpong Harga',
            image:
              'https://bydbsdserpong.com/static/media/logo.2a151e9e6824f6e000cd.webp ',
            description:
              'SUV listrik terbaru dengan performa tinggi, dirancang oleh Wolfgang Egger.',
            brand: {
              '@type': 'Brand',
              name: 'BYD',
            },
            offers: {
              '@type': 'Offer',
              price: 719000000,
              priceCurrency: 'IDR',
              availability: 'https://schema.org/InStock',
              url: 'https://bydbsdserpong.com',
            },
          })}
        </script>
      </Helmet>

      <Typography
        variant='h1'
        component='h1'
        fontWeight='bold'
        sx={{
          textAlign: 'center',
          marginBottom: 4,
          fontSize: { xs: '2rem', sm: '2.5rem' },
        }}
      >
        Daftar Harga
      </Typography>

      <Divider sx={{ marginBottom: 4 }} />

      <Grid container spacing={4}>
        {vehicles.map((vehicle, index) => {
          const selectedIndex = selectedVariants[vehicle.name] || 0;
          const selectedVariant = vehicle.variants[selectedIndex];

          return (
            <Grid item xs={12} sm={6} key={index}>
              <Box
                sx={{
                  textAlign: 'center',
                  position: 'relative',
                  padding: { xs: 2, sm: 4 },
                  backgroundColor: '#f9f9f9',
                  borderRadius: '12px',
                  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                  height: '100%',
                }}
              >
                {vehicle.isNew && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 8,
                      left: 8,
                      backgroundColor: '#e53935',
                      color: '#fff',
                      fontSize: 12,
                      fontWeight: 'bold',
                      px: 1,
                      py: 0.3,
                      borderRadius: '4px',
                      animation: 'blinker 1s linear infinite',
                      boxShadow: '0 0 6px rgba(255,0,0,0.6)',
                      zIndex: 2,
                    }}
                  >
                    🔥 HOT! NEW!
                  </Box>
                )}

                <Box
                  sx={{ position: 'relative', width: '80%', margin: '0 auto' }}
                >
                  <Box
                    component='img'
                    src={vehicle.image}
                    loading='lazy'
                    width='100%'
                    height='auto'
                    sx={{ display: 'block' }}
                  />
                </Box>

                <Typography
                  variant='h5'
                  fontWeight='bold'
                  sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }}
                >
                  {vehicle.name}
                </Typography>

                {vehicle.isComingSoon ? (
                  <Button
                    variant='outlined'
                    color='primary'
                    href='https://api.whatsapp.com/send?phone=6281286864825&text=Halo%20saya%20mau%20tau%20info%20BYD%20nya'
                    target='_blank'
                    sx={{ textTransform: 'none' }}
                  >
                    Coming Soon! Book Now
                  </Button>
                ) : (
                  <Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        gap: 2,
                        marginBottom: 2,
                      }}
                    >
                      {vehicle.variants.map((variant, idx) => (
                        <Box
                          key={idx}
                          onClick={() => {
                            setSelectedVariants((prev) => ({
                              ...prev,
                              [vehicle.name]: idx,
                            }));
                          }}
                          sx={{
                            border:
                              idx === selectedIndex
                                ? '2px solid #1976d2'
                                : '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '10px 20px',
                            textAlign: 'center',
                            minWidth: '150px',
                            cursor: 'pointer',
                            backgroundColor:
                              idx === selectedIndex ? '#e3f2fd' : 'transparent',
                            transition: '0.2s ease',
                          }}
                        >
                          <Typography
                            variant='body1'
                            fontWeight='bold'
                            sx={{ fontSize: '1rem', marginBottom: 1 }}
                          >
                            {variant.type}
                          </Typography>
                          <Typography variant='body2' sx={{ color: '#555' }}>
                            {variant.description}
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    <Typography
                      variant='h5'
                      fontWeight='bold'
                      sx={{
                        marginBottom: 1,
                        fontSize: { xs: '1.5rem', sm: '1.8rem' },
                      }}
                    >
                      {selectedVariant.price}
                    </Typography>

                    <Typography
                      variant='body2'
                      sx={{ marginBottom: 2, color: '#888' }}
                    >
                      OTR Jakarta (IDR) | Harga NIK 2026
                    </Typography>

                    {selectedVariant.dressUp && (
                      <Box
                        sx={{
                          mt: 2,
                          mb: 2,
                          p: 1.5,
                          borderRadius: '10px',
                          background:
                            'linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%)',
                          border: '1px solid #f4d06f',
                          textAlign: 'left',
                          maxWidth: '100%',
                        }}
                      >
                        <Typography
                          variant='subtitle2'
                          sx={{
                            fontWeight: 700,
                            color: '#8a6d1d',
                            mb: 1,
                            textAlign: 'center',
                            fontSize: '0.95rem',
                          }}
                        >
                          🎁 {selectedVariant.dressUp.title}
                        </Typography>

                        <Box
                          component='img'
                          src={selectedVariant.dressUp.image}
                          alt='ATTO 1 Dress Up Package'
                          sx={{
                            width: '100%',
                            maxHeight: 260,
                            objectFit: 'contain',
                            borderRadius: '8px',
                            mb: 1.2,
                            display: 'block',
                            border: '1px solid rgba(0,0,0,0.08)',
                            backgroundColor: '#fffdf5',
                          }}
                        />

                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                            gap: 0.5,
                          }}
                        >
                          {selectedVariant.dressUp.items.map((item, idx) => (
                            <Typography
                              key={idx}
                              variant='caption'
                              sx={{
                                color: '#444',
                                fontSize: '0.78rem',
                                lineHeight: 1.4,
                              }}
                            >
                              • {item}
                            </Typography>
                          ))}
                        </Box>

                        <Typography
                          variant='caption'
                          sx={{
                            display: 'block',
                            mt: 1,
                            color: '#7a7a7a',
                            textAlign: 'center',
                            fontSize: '0.72rem',
                          }}
                        >
                          Paket aksesoris mengikuti program dan ketersediaan.
                        </Typography>
                      </Box>
                    )}

                    <Divider sx={{ marginBottom: 2 }} />

                    <Box>
                      {selectedVariant.details.map((detail, idx) => (
                        <Box key={idx}>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              paddingX: 2,
                              marginBottom: 1,
                              gap: 2,
                            }}
                          >
                            <Typography
                              variant='body1'
                              sx={{
                                fontSize: { xs: '0.9rem', sm: '1rem' },
                                color: '#555',
                                textAlign: 'left',
                              }}
                            >
                              {detail.label}
                            </Typography>
                            <Typography
                              variant='body2'
                              sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                fontWeight: 600,
                                textAlign: 'right',
                              }}
                            >
                              {detail.value}
                            </Typography>
                          </Box>
                          <Divider />
                        </Box>
                      ))}

                      <Button
                        variant='contained'
                        color='primary'
                        fullWidth
                        href={`https://api.whatsapp.com/send?phone=6281286864825&text=Halo%2C%20saya%20tertarik%20dengan%20${encodeURIComponent(
                          vehicle.name,
                        )}%20tipe%20${encodeURIComponent(
                          selectedVariant.type,
                        )}.%20Mohon%20info%20harga%20dan%20promonya.`}
                        target='_blank'
                        sx={{
                          mt: 2,
                          textTransform: 'none',
                          fontWeight: 600,
                          fontSize: { xs: '0.95rem', sm: '1rem' },
                        }}
                      >
                        Pesan Sekarang via WhatsApp
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>

      <style>
        {`
          @keyframes blinker {
            0% { opacity: 1; }
            50% { opacity: 0.1; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </Box>
  );
}

export default Pricing;
